import React from 'react';

interface GoogleCalendarButtonProps {
  url: string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  iconClassName?: string;
  onClick?: () => void;
}

export const GoogleCalendarButton: React.FC<GoogleCalendarButtonProps> = ({
  url,
  title = 'Adicionar ao Google Calendar',
  className = '',
  style = {},
  iconClassName = 'fas fa-calendar-plus',
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick();
    window.open(url, '_blank');
  };
  return (
    <button
      type="button"
      className={`google-calendar-btn ${className}`}
      title={title}
      style={style}
      onClick={handleClick}
    >
      <i className={iconClassName}></i>
    </button>
  );
}; 